import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Heading,
  BackToHomeBtn,
  NotFoundContainer,
  SubHeading,
} from './styles';
import { menuItemObj } from '../../components/PrivatePage';

const NotFound404 = () => {
  const navigate = useNavigate();
  const navigateToHomeHandler = () => navigate(menuItemObj.home);

  return (
    <NotFoundContainer>
      <Heading>404</Heading>
      <SubHeading>Sorry, Page Not Found</SubHeading>
      <BackToHomeBtn onClick={navigateToHomeHandler}>
        Back To Home
      </BackToHomeBtn>
    </NotFoundContainer>
  );
};

export default NotFound404;
